var $9d503476b9d858b7$exports = {};
$9d503476b9d858b7$exports = {
    "close": `Kapat`,
    "notifications": `Bildirimler`
};


export {$9d503476b9d858b7$exports as default};
//# sourceMappingURL=tr-TR.mjs.map
